import { render, staticRenderFns } from "./item-tab.vue?vue&type=template&id=3d9f9af8&scoped=true"
import script from "./item-tab.vue?vue&type=script&lang=js"
export * from "./item-tab.vue?vue&type=script&lang=js"
import style0 from "./item-tab.vue?vue&type=style&index=0&id=3d9f9af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f9af8",
  null
  
)

export default component.exports